import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5736dc90&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=5736dc90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5736dc90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5736dc90')) {
      api.createRecord('5736dc90', component.options)
    } else {
      api.reload('5736dc90', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5736dc90&scoped=true&", function () {
      api.rerender('5736dc90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/modules/goods-change-dialog/index.vue"
export default component.exports